import { IconArrowNarrowLeft, IconArrowNarrowRight, IconDots } from "@tabler/icons-react";
import ReactPaginate from "react-paginate";

type PaginationProps = {
	onClick: (page: number) => void;
	initialPage?: number;
	pageCount?: number;
	itemsPerPage?: number;
	onItemsPerPageChange?: (value: number) => void;
	itemsPerPageOptions?: number[];
};

export default function Pagination({
	onClick,
	initialPage = 1,
	pageCount = 1,
	itemsPerPage = 10,
	onItemsPerPageChange,
	itemsPerPageOptions = [10, 20, 50, 100],
}: PaginationProps) {
	const handlePageClick = (e: { selected: number }) => {
		onClick(e.selected + 1);
	};

	const handleItemsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const value = Number.parseInt(e.target.value, 10);
		if (onItemsPerPageChange) {
			onItemsPerPageChange(value);
			onClick(1); // Reset to first page when changing items per page
		}
	};

	// if (pageCount <= 1 && itemsPerPage >= 100) return;

	return (
		<div className="flex flex-row justify-between items-center w-full">
			<div className="inline-flex flex-row items-center self-center gap-4">
				<div className="inline-flex flex-row items-center self-center gap-1">
					<span className="text-base text-foreground">Showing Pages</span>
					<div className="text-base text-foreground">
						<span className="font-bold text-foreground-dark">{initialPage}</span> of <span className="font-bold text-foreground-dark">{pageCount}</span>
					</div>
				</div>
				{onItemsPerPageChange && (
					<div className="inline-flex flex-row items-center gap-2">
						<label htmlFor="items-per-page" className="text-base text-foreground">
							Items per page:
						</label>
						<select
							id="items-per-page"
							value={itemsPerPage}
							onChange={handleItemsPerPageChange}
							className="px-2 py-1 text-sm border border-border rounded-md bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
						>
							{itemsPerPageOptions.map((option) => (
								<option key={option} value={option}>
									{option}
								</option>
							))}
						</select>
					</div>
				)}
			</div>
			<ReactPaginate
				breakLabel={
					<div className="inline-flex justify-center items-center text-xs w-[32px] h-[32px] hover:bg-slate-50 rounded-md border border-border bg-white text-foreground/50">
						<IconDots size={18} stroke={1.5} />
					</div>
				}
				breakClassName="pagination__nav__item pagination__nav__item--break"
				nextLabel={
					<div className="inline-flex justify-center items-center w-[32px] h-[32px] rounded-md border bg-white hover:bg-slate-50 text-foreground border-border/50 hover:border-border">
						<IconArrowNarrowRight size={18} stroke={1.5} />
					</div>
				}
				previousLabel={
					<div className="inline-flex justify-center items-center w-[32px] h-[32px] rounded-md border bg-white hover:bg-slate-50 text-foreground border-border/50 hover:border-border">
						<IconArrowNarrowLeft size={18} stroke={1.5} />
					</div>
				}
				disableInitialCallback={true}
				renderOnZeroPageCount={() => null}
				initialPage={initialPage - 1}
				onPageChange={handlePageClick}
				pageClassName="inline-flex justify-center items-center text-base w-[32px] h-[32px] rounded-md border border-border/50 hover:border-border hover:bg-slate-50 text-foreground"
				pageLinkClassName="inline-flex justify-center items-center text-base w-[32px] h-[32px] rounded-md "
				activeClassName="!bg-primary-600 !hover:bg-primary-500 !border-primary-600 !text-white"
				containerClassName="flex flex-row gap-1.5 self-center justify-start items-start w-auto h-auto"
				pageRangeDisplayed={3}
				pageCount={pageCount !== 1 ? pageCount : 0}
			/>
		</div>
	);
}
